import ConflictsViewState from './schema/ConflictsViewState';
import { createStore } from 'satcheljs';

const getStore = createStore<ConflictsViewState>('ConflictsViewStore', {
    meetingRequest: null,
    futureInstances: null,
    selectedInstanceIndex: null,
});

export default getStore;
